import React, { useEffect, useState } from "react";
import logo from "../../assets/images/Equity Pal.png"
import userIco from "../../assets/images/User.png";
import passwordIco from "../../assets/images/Password.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginService } from "../../services/user.service";
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { selectUserData, setLoginData } from "../../reducers/user.reducer";
import { decryptFun } from "../../utils/helper";

function Login() {
  const dispatch = useDispatch();
  const { rememberMe, credential } = useSelector(selectUserData);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (rememberMe && credential) {
      const { username, password } = decryptFun(credential);
      setUsername(username);
      setPassword(password);
    }
  }, [credential, rememberMe]);

  const loginAction = async (e) => {
    try {
      e?.preventDefault();
      if (!username) {
        setUsernameError("Username is required");
      } else {
        setUsernameError("");
      }
      if (!password) {
        setPasswordError("Password is required");
      } else {
        setPasswordError("");
      }
      if (username && password) {
        dispatch(setIsLoading(true));
        const result = await loginService({ username, password });
        if (result?.data) {
          const { token, refreshToken, user } = result?.data;
          await dispatch(
            setLoginData({
              username,
              password,
              token,
              user,
              rememberMe,
              refreshToken,
            })
          );
          navigate("/dashboard");
        }
      }
    } catch (error) {
      dispatch(
        setToastMessage({
          message: error?.response?.data?.message || error?.message,
          type: "error",
        })
      );
    } finally {
      dispatch(setIsLoading(false));
    }
  };
  return (
    <> 
      <div className="flex justify-center items-center bg-bgcol h-full w-full ">
        <div className="bg-white rounded-md h-[515px] w-[300px]">
          <form
            className="flex flex-col justify-center items-center h-full w-full"
            onSubmit={(e) => loginAction(e)}
            method="POST"
          >
            <div className="flex flex-col items-center text-textcol mb-16 ">
              <img src={logo} className="w-[100px]" alt="" />
              {/* <h2 className="font-bold text-lg">Equity Pal</h2> */}
              <h4 className="font-semibold mt-5">Business Share Manager</h4>
            </div>
            <div className="flex flex-col text-sm font-semibold w-[80%] sm:w-[65%] mb-12">
              <div className="flex items-center bg-slate-50 rounded-lg mb-1 w-full">
                <img src={userIco} className="h-[30px] ml-3" alt="" />
                <input
                  type="text"
                  className="py-3 bg-slate-50 focus:outline-none w-full rounded-lg"
                  name=""
                  id="txtUserName"
                  placeholder="UserName"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="text-center mb-3">
                {usernameError && <p className="text-red">{usernameError}</p>}
              </div>
              
              <div className="flex items-center bg-slate-50 mb-1 rounded-lg">
                <img src={passwordIco} className="h-[30px] ml-3" alt="" />
                <input
                  type="password"
                  className="py-3 bg-slate-50 focus:outline-none w-full rounded-lg"
                  name=""
                  id="txtPassword"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>             
              <div className="text-center">
                {passwordError &&( <p className="text-red">{passwordError}</p>)}
              </div>    
            </div>

            <div className="">
              <button
                type="submit"
                className="rounded-full bg-primary text-white hover:bg-hovercol font-semibold px-10 py-2"
              >
                LOGIN
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;